import { cn } from "@/lib/utils";

interface BrandLogoProps {
  size?: "sm" | "md" | "lg";
  /** Kept for API compatibility — the logo image already includes the wordmark. */
  showWordmark?: boolean;
  className?: string;
}

const sizeMap = {
  sm: "h-8",
  md: "h-10",
  lg: "h-24",
};

/**
 * Febi.ai brand logo — uses the real logo asset in /public/febi-logo.png.
 * The image is a vertical lockup (icon + "Febi.ai" wordmark), so the separate
 * text wordmark is intentionally not rendered.
 */
export function BrandLogo({ size = "sm", className }: BrandLogoProps) {
  return (
    <img
      src="/febi-logo.png"
      alt="Febi.ai"
      className={cn("w-auto object-contain select-none", sizeMap[size], className)}
      draggable={false}
    />
  );
}
